export const locale = {
    lang: 'ar',
    data: {
        CREATE_SUB_PROJECT: 'إنشاء مشروع فرعي',
        GENERAL: 'عموميات',
        MEMBERS: 'الأعضاء'
    }
};
